<template>
  <div>
    <section id="banners" class="d-flex flex-column justify-center align-center w-full">
      <div v-for="banner in activeBanners" :key="banner.id" class="mb-2">
        <img
          v-if="banner.image || getDynamicImage(banner)"
          :src="banner.image || getDynamicImage(banner)"
          :style="`max-width: ${banner.width || '900px'}`"
          :height="banner.height || 'auto'"
          :alt="banner.tagline"
          :title="banner.tagline"
          width="100%"
        />
      </div>
    </section>

    <div
      v-if="$store.getters.hasReturnData && $route.name !== 'pageOne'"
      class="primary white--text d-block py-3 px-3 mb-3"
      :style="`max-width: ${activeBanners[0].width || '900px'}; margin: auto;`"
    >
      <h3>Your Collection / Return</h3>
      <v-divider class="mt-2 mb-2" />
      <h5>Collection: <strong>{{ $store.getters.momentCollectionDate.format('ddd Do MMM') }}</strong></h5>
      <h5>Return: <strong>{{ $store.getters.momentReturnDate.format('ddd Do MMM') }}</strong></h5>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Banners',

  computed: {
    ...mapGetters([
      'activeBanners'
    ])
  },

  methods: {
    getDynamicImage (banner) {
      if (banner.id === 'TPB1') {
        var min = Math.ceil(1)
        var max = Math.floor(10)
        var number = Math.floor(Math.random() * (max - min) + min)

        if (this.$store.getters.getDefaultService === 'regular' || this.$store.getters.getDefaultService === 'regular_electric') {
          return `https://d2w46cz0afxd34.cloudfront.net/assets/regular_service_review_banner_${number}.png`
        }

        if (this.$store.getters.getDefaultService === 'deluxe' || this.$store.getters.getDefaultService === 'deluxe_electric') {
          return `https://d2w46cz0afxd34.cloudfront.net/assets/deluxe_service_review_banner_${number}.png`
        }

        if (this.$store.getters.getDefaultService === 'super_deluxe' || this.$store.getters.getDefaultService === 'super_deluxe_electric') {
          return `https://d2w46cz0afxd34.cloudfront.net/assets/super_deluxe_service_review_banner_${number}.png`
        }

        return `https://d2w46cz0afxd34.cloudfront.net/assets/service_review_banner_${number}.png`
      }
    }
  }
}
</script>
